import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import ExclusionReasonPage from './ExclusionReasonPage';

class ExclusionReasonsPage extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  render() {
    const { location: { pathname } } = this.props;
    return (
      <div>
        <Helmet title="Exclusion Reasons Setup" />
        <div className="container">
          <div className="well">
            Define the reasons reps can select from when excluding an opportunity or contact from feedback requests. Exclusion reasons for opportunity-based automation (e.g., decision feedback) and account-based automation (e.g., customer experience feedback) are defined separately.
          </div>

          <div>
            <ul className="nav nav-tabs">
              <LinkContainer to="/setup/exclusion-reasons/opportunities">
                <NavItem>Decision Reasons</NavItem>
              </LinkContainer>
              <LinkContainer to="/setup/exclusion-reasons/accounts">
                <NavItem>Experience Reasons</NavItem>
              </LinkContainer>
            </ul>
            <p />
          </div>
          <Switch>
            <Route path="/setup/exclusion-reasons/:source" key={pathname} component={ExclusionReasonPage} />
            {(pathname === '/setup/exclusion-reasons' && <Redirect to="/setup/exclusion-reasons/opportunities" />)}
          </Switch>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ExclusionReasonsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

ExclusionReasonsPage.contextTypes = {
  router: PropTypes.shape({}),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(withRouter(ExclusionReasonsPage));
